import { gql } from '@apollo/client';
import { USER_HAS_ENDING_DTO } from './fragment/story';

export const STORIES_HAVING_ENDING = gql`
  query StoriesHavingEnding {
    listStoryByAppHavingEndingOrAchievementV3 {
      list {
        shareKey
        storyId
        isFinished
        hasAchievement
        name
        mainImageFile {
          link
        }
        lastPlay {
          firstName
          lastName
          playedChapters {
            chapterId
            ending {
              endingId
            }
          }
        }
        endingInfo {
          numTotalEnding
          endings {
            ending {
              endingId
            }
            userHasEnding {
              ending {
                storyId
              }
            }
          }
        }
      }
    }
  }
`;

export const ENDING_STATS_PER_CHAPTER = gql`
  query EndingStatsPerChapter($chapterId: Int!) {
    endingData: getEndingStatsPerChapter(data: { id: $chapterId }) {
      endingWithStats {
        ending {
          endingId
          name
          displayName
          collectionDescription
          shareKey
          chapterId
          isFinal
          imageFile {
            link
          }
          chapter {
            name
            chapterIndex
          }
          story {
            name
            storyId
            mainImageFile {
              link
            }
            chapters {
              chapterId
              chapterIndex
              name
            }
            characters {
              name
              defaultFirstName
              defaultLastName
              displayName
            }
            lastPlay {
              lastName
              firstName
              currentPlayingChapter {
                playingCharacters {
                  characterId
                  firstName
                  lastName
                  profileImageFileId
                  character {
                    name
                  }
                }
              }
            }
          }
        }
        percentage
      }
      endingInfo {
        numTotalEnding
        endings {
          userHasEnding {
            ...UserHasEndingDto
          }
          ending {
            endingId
            name
            collectionDescription
            chapter {
              name
            }
            previewName
            isFinal
            rateLevel
            arrivalRate
            shareKey
            story {
              name
            }
            imageFile {
              link
            }
            previewImageFile {
              link
            }
          }
        }
      }
    }
  }
  ${USER_HAS_ENDING_DTO}
`;

export const GET_USER_PLAYER_REPORT = gql`
  query GetUserPlayerReport($id: Int!) {
    getUserPlayerReport(data: { id: $id }) {
      url
      storyId
      storyName
      reportId
      endingId
    }
  }
`;

export const GET_ENDING_BY_SHARE_KEY = gql`
  query getEndingByShareKey($data: SingleStringIDInput!) {
    getEndingByShareKey(data: $data) {
      storyId
      storyName
      chapterName
      chapterIndex
      endingImageLink
      endingName
      percentage
    }
  }
`;

export const GET_FINAL_ENDING_BY_SHARE_KEY = gql`
  query getFinalEndingByShareKey($id: String!) {
    getEndingByShareKey(data: { id: $id }) {
      storyId
      storyName
      userName
      endingImageLink
      endingName
      endingDescription
      endingCreatedAt
      endingArrivalRate
      endingRateLevel
      endingCardList {
        type
        arrivalRate
        rateLevel
        choiceCount
        endingCollectRate
        characterImageLink
      }
    }
  }
`;

export const LIST_HAVING_ENDING = gql`
  query ListHavingEnding {
    listStoryByAppHavingEnding {
      list {
        storyId
        name
        lastPlay {
          userId
          firstName
          lastName
        }
        endingInfo {
          endings {
            ending {
              name
              endingId
              storyId
              imageFile {
                link
              }
            }
            userHasEnding {
              ending {
                endingId
              }
            }
          }
        }
      }
    }
  }
`;
